// A plain ISO day from the API, as the date somebody reads.
//
// Read off the string rather than through `new Date`, which parses
// '2026-09-15' as midnight UTC and then renders it in the browser's
// timezone -- which in California is the day before.
//
// Shared by the companies list and the people list, which show the same
// LAST CONTACT column from two different sources (home/backend/
// company_contact.py and person_contact.py). It lives here rather than in
// either page because importing one list into the other to borrow six
// lines drags a whole screen's module in with it.
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export function formatContactDate(value) {
    const parts = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value || ''));
    if (!parts) return '';
    const month = MONTHS[Number(parts[2]) - 1];
    return month ? `${month} ${Number(parts[3])}, ${parts[1]}` : '';
}
